export default "__VITE_ASSET___$cCm4Hv__"